import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Flex } from '../../../components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const spacingToToken = {
  none: '0',
  'extra-small': '200',
  small: '300',
  medium: '400',
  large: '500',
  'extra-large': '600'
};
export const Media = _ref => {
  let {
      children,
      align,
      spacing = 'small',
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["children", "align", "spacing", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    alignItems: align,
    flexDirection: "row",
    columnGap: spacingToToken[spacing]
  }, rest, {
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'Media',
    children: children
  }));
};
Media.displayName = 'Media';